import { useRef, useEffect } from 'react';

// Input parameters
export interface OutsideClickHandlerInput {
  action: () => void; // Only action is required
  resetOnNewAction?: boolean;
  active?: boolean;
  dependencies?: any[];
}
export function useOutsideClickHandler<T extends HTMLElement>(input: OutsideClickHandlerInput) {
  // Defaults
  const active = input.active ?? true;
  const action = input.action ?? undefined;
  const resetOnNewAction = input.resetOnNewAction ?? false;
  const dependencies = input.dependencies ?? [];

  // Reference to parent container (clicking outside of this should trigger the action)
  const clickParentRef = useRef<T | null>(null);

  // Effect to assing the event listeners
  useEffect(() => {
    // Don't bother if inactive
    if (!active) return;

    // Setup the click handler
    const clickHandler = (event: any) => {
      // Check if event target element is inside
      if (clickParentRef.current && !clickParentRef.current?.contains(event.target)) {
        action();
      }
    };

    // Event listener add/cleanup
    document.addEventListener('click', clickHandler, true);
    return () => document.removeEventListener('click', clickHandler, true);
  }, [resetOnNewAction ? action : undefined, active, ...dependencies]);

  // Return the dependency
  return clickParentRef;
}
